import { filter } from 'lodash';


const user = (state = {}, action) => {
  switch (action.type) {
    //  <----------- START NOIZ V2 REDUCERS LOGIC ---------->
    case 'GET_INITIAL_INFO_PENDING':
      return {
        ...state,
        myPreApprovedGameKeys: {
          ...state.myPreApprovedGameKeys,
          isLoading: true,
          errors: {
            ...state.myPreApprovedGameKeys.errors,
            hasError: false,
            code: '',
            message: '',
          },
        },
        myBounties: {
          ...state.myBounties,
          isLoading: true,
          errors: {
            ...state.myBounties.errors,
            hasError: false,
            code: '',
            message: '',
          },
        },
        myQuests: {
          ...state.myQuests,
          isLoading: true,
          errors: {
            ...state.myQuests.errors,
            hasError: false,
            code: '',
            message: '',
          },
        },
        myUserQuests: {
          ...state.myUserQuests,
          isLoading: true,
          errors: {
            ...state.myUserQuests.errors,
            hasError: false,
            code: '',
            message: '',
          },
        },
        timedActivity: {
          ...state.timedActivity,
          isLoading: true,
          errors: {
            ...state.timedActivity.errors,
            hasError: false,
            code: '',
            message: '',
          },
        },
      };
    case 'GET_INITIAL_INFO_ERROR':
      return {
        ...state,
        myPreApprovedGameKeys: {
          ...state.myPreApprovedGameKeys,
          isLoading: false,
          errors: {
            ...state.myPreApprovedGameKeys.errors,
            hasError: action.payload.error,
            code: action.payload.code,
            message: action.payload.message,
            all: action.payload.errors,
          },
        },
        myBounties: {
          ...state.myBounties,
          isLoading: false,
          errors: {
            ...state.myBounties.errors,
            hasError: action.payload.error,
            code: action.payload.code,
            message: action.payload.message,
            all: action.payload.errors,
          },
        },
        myQuests: {
          ...state.myQuests,
          isLoading: false,
          errors: {
            ...state.myQuests.errors,
            hasError: false,
            code: '',
            message: '',
          },
        },
        myUserQuests: {
          ...state.myUserQuests,
          isLoading: false,
          errors: {
            ...state.myUserQuests.errors,
            hasError: false,
            code: '',
            message: '',
          },
        },
        timedActivity: {
          ...state.timedActivity,
          isLoading: false,
          errors: {
            ...state.timedActivity.errors,
            hasError: false,
            code: '',
            message: '',
          },
        },
      };
    case 'GET_INITIAL_INFO_ABORTED':
      return {
        ...state,
        myPreApprovedGameKeys: {
          ...state.myPreApprovedGameKeys,
          isLoading: false,
          errors: {
            ...state.myPreApprovedGameKeys.errors,
            hasError: false,
            code: '',
            message: '',
          },
        },
        myBounties: {
          ...state.myBounties,
          isLoading: false,
          errors: {
            ...state.myBounties.errors,
            hasError: false,
            code: '',
            message: '',
          },
        },
        myQuests: {
          ...state.myQuests,
          isLoading: false,
          errors: {
            ...state.myQuests.errors,
            hasError: false,
            code: '',
            message: '',
          },
        },
        myUserQuests: {
          ...state.myUserQuests,
          isLoading: false,
          errors: {
            ...state.myUserQuests.errors,
            hasError: false,
            code: '',
            message: '',
          },
        },
        timedActivity: {
          ...state.timedActivity,
          isLoading: false,
          errors: {
            ...state.timedActivity.errors,
            hasError: false,
            code: '',
            message: '',
          },
        },
      };
    case 'GET_INITIAL_INFO_SUCCESS':
      return {
        ...state,
        myPreApprovedGameKeys: {
          ...state.myPreApprovedGameKeys,
          data: action.payload.response.data.myPreApprovedGameKeys,
          isLoading: false,
          errors: {
            ...state.myPreApprovedGameKeys.errors,
            hasError: false,
            code: '',
            message: '',
          },
        },
        myBounties: {
          ...state.myBounties,
          data: action.payload.response.data.myBounties,
          isLoading: false,
          errors: {
            ...state.myBounties.errors,
            hasError: false,
            code: '',
            message: '',
          },
        },
        myQuests: {
          ...state.myQuests,
          data: action.payload.response.data.myQuests,
          isLoading: false,
          errors: {
            ...state.myQuests.errors,
            hasError: false,
            code: '',
            message: '',
          },
        },
        myUserQuests: {
          ...state.myUserQuests,
          data: action.payload.response.data.myUserQuests,
          isLoading: false,
          errors: {
            ...state.myUserQuests.errors,
            hasError: false,
            code: '',
            message: '',
          },
        },
        timedActivity: {
          ...state.timedActivity,
          data: action.payload.response.data.timedActivity,
          isLoading: false,
          errors: {
            ...state.myUserQuests.errors,
            hasError: false,
            code: '',
            message: '',
          },
        },
      };
    case 'REQUEST_GAME_KEY_PENDING':
      return {
        ...state,
        myPreApprovedGameKeys: {
          ...state.myPreApprovedGameKeys,
          isLoading: true,
          isRequestingAGameKey: true,
          errors: {
            ...state.myPreApprovedGameKeys.errors,
            hasError: false,
            code: '',
            message: '',
          },
        },
      };
    case 'REQUEST_GAME_KEY_ERROR':
      return {
        ...state,
        myPreApprovedGameKeys: {
          ...state.myPreApprovedGameKeys,
          isLoading: false,
          isRequestingAGameKey: false,
          errors: {
            ...state.myPreApprovedGameKeys.errors,
            hasError: action.payload.error,
            code: action.payload.code,
            message: action.payload.message,
            all: action.payload.errors,
          },
        },
      };
    case 'REQUEST_GAME_KEY_ABORTED':
      return {
        ...state,
        myPreApprovedGameKeys: {
          ...state.myPreApprovedGameKeys,
          isLoading: false,
          isRequestingAGameKey: false,
          errors: {
            ...state.myPreApprovedGameKeys.errors,
            hasError: false,
            code: '',
            message: '',
          },
        },
      };
    case 'REQUEST_GAME_KEY_SUCCESS': {
      return {
        ...state,
        game: {
          data: action.payload.response.game,
        },
        myPreApprovedGameKeys: {
          ...state.myPreApprovedGameKeys,
          data: [
            filter(state.myPreApprovedGameKeys.data, action.payload.response.game.id),
            action.payload.response.game,
          ],
          isLoading: false,
          isRequestingAGameKey: false,
          errors: {
            ...state.myPreApprovedGameKeys.errors,
            hasError: false,
            code: '',
            message: '',
          },
        },
      };
    }
    case 'JOIN_TO_BOUNTY_PENDING':
      return {
        ...state,
        myBounties: {
          ...state.myBounties,
          isLoading: true,
          isJoiningToABounty: true,
          errors: {
            ...state.myBounties.errors,
            hasError: false,
            code: '',
            message: '',
          },
        },
      };
    case 'JOIN_TO_BOUNTY_ERROR':
      return {
        ...state,
        myBounties: {
          ...state.myBounties,
          isLoading: false,
          isJoiningToABounty: false,
          errors: {
            ...state.myBounties.errors,
            hasError: action.payload.error,
            code: action.payload.code,
            message: action.payload.message,
            all: action.payload.errors,
          },
        },
      };
    case 'JOIN_TO_BOUNTY_ABORTED':
      return {
        ...state,
        myBounties: {
          ...state.myBounties,
          isLoading: false,
          isJoiningToABounty: false,
          errors: {
            ...state.myBounties.errors,
            hasError: false,
            code: '',
            message: '',
          },
        },
      };
    case 'JOIN_TO_BOUNTY_SUCCESS': {
      return {
        ...state,
        myBounties: {
          ...state.myBounties,
          data: [
            ...filter(state.myBounties.data, bounty => action.payload.response.bounty.id !== bounty.id),
            action.payload.response.bounty,
          ],
          isLoading: false,
          isJoiningToABounty: false,
          errors: {
            ...state.myBounties.errors,
            hasError: false,
            code: '',
            message: '',
          },
        },
      };
    }
    case 'LEAVE_BOUNTY_PENDING':
      return {
        ...state,
        myBounties: {
          ...state.myBounties,
          isLoading: true,
          isLeavingABounty: true,
          errors: {
            ...state.myBounties.errors,
            hasError: false,
            code: '',
            message: '',
          },
        },
      };
    case 'LEAVE_BOUNTY_ERROR':
      return {
        ...state,
        myBounties: {
          ...state.myBounties,
          isLoading: false,
          isLeavingABounty: false,
          errors: {
            ...state.myBounties.errors,
            hasError: action.payload.error,
            code: action.payload.code,
            message: action.payload.message,
            all: action.payload.errors,
          },
        },
      };
    case 'LEAVE_BOUNTY_ABORTED':
      return {
        ...state,
        myBounties: {
          ...state.myBounties,
          isLoading: false,
          isLeavingABounty: false,
          errors: {
            ...state.myBounties.errors,
            hasError: false,
            code: '',
            message: '',
          },
        },
      };
    case 'LEAVE_BOUNTY_SUCCESS': {
      return {
        ...state,
        myBounties: {
          ...state.myBounties,
          data: [
            ...filter(state.myBounties.data, bounty => action.payload.response.bounty.id !== bounty.id),
          ],
          isLoading: false,
          isLeavingABounty: false,
          errors: {
            ...state.myBounties.errors,
            hasError: false,
            code: '',
            message: '',
          },
        },
      };
    }
    //  <----------- END NOIZ V2 REDUCERS LOGIC ---------->
    case 'JOIN_QUEST_PENDING':
      return {
        ...state,
        myQuests: {
          ...state.myQuests,
          isLoading: true,
          isJoiningToAQuest: true,
          errors: {
            ...state.myQuests.errors,
            hasError: false,
            code: '',
            message: '',
          },
        },
        myUserQuests: {
          ...state.myUserQuests,
          isLoading: true,
          isJoiningToAQuest: true,
          errors: {
            ...state.myUserQuests.errors,
            hasError: false,
            code: '',
            message: '',
          },
        },
      };
    case 'JOIN_QUEST_ERROR':
      return {
        ...state,
        myQuests: {
          ...state.myQuests,
          isLoading: false,
          isJoiningToAQuest: false,
          errors: {
            ...state.myQuests.errors,
            hasError: action.payload.error,
            code: action.payload.code,
            message: action.payload.message,
            all: action.payload.errors,
          },
        },
        myUserQuests: {
          ...state.myUserQuests,
          isLoading: false,
          isJoiningToAQuest: false,
          errors: {
            ...state.myUserQuests.errors,
            hasError: action.payload.error,
            code: action.payload.code,
            message: action.payload.message,
            all: action.payload.errors,
          },
        },
      };
    case 'JOIN_QUEST_ABORTED':
      return {
        ...state,
        myQuests: {
          ...state.myQuests,
          isLoading: false,
          isJoiningToAQuest: false,
          errors: {
            ...state.myQuests.errors,
            hasError: false,
            code: '',
            message: '',
          },
        },
        myUserQuests: {
          ...state.myUserQuests,
          isLoading: false,
          isJoiningToAQuest: false,
          errors: {
            ...state.myUserQuests.errors,
            hasError: false,
            code: '',
            message: '',
          },
        },
      };
    case 'JOIN_QUEST_SUCCESS':
      return {
        ...state,
        myQuests: {
          ...state.myQuests,
          data: [
            ...state.myQuests.data,
            action.payload.response.quest,
          ],
          isLoading: false,
          isJoiningToAQuest: false,
          errors: {
            ...state.myQuests.errors,
            hasError: false,
            code: '',
            message: '',
          },
        },
        myUserQuests: {
          ...state.myUserQuests,
          data: [
            ...filter(state.myUserQuests.data, userQuest => action.payload.response.userQuest.id !== userQuest.id),
            action.payload.response.userQuest,
          ],
          isLoading: false,
          isJoiningToAQuest: false,
          errors: {
            ...state.myUserQuests.errors,
            hasError: false,
            code: '',
            message: '',
          },
        },
      };
    case 'LEAVE_QUEST_PENDING':
      return {
        ...state,
        myQuests: {
          ...state.myQuests,
          isLoading: true,
          isLeavingAQuest: true,
          errors: {
            ...state.myQuests.errors,
            hasError: false,
            code: '',
            message: '',
          },
        },
      };
    case 'LEAVE_QUEST_ERROR':
      return {
        ...state,
        myQuests: {
          ...state.myQuests,
          isLoading: false,
          isLeavingAQuest: false,
          errors: {
            ...state.myQuests.errors,
            hasError: action.payload.error,
            code: action.payload.code,
            message: action.payload.message,
            all: action.payload.errors,
          },
        },
      };
    case 'LEAVE_QUEST_ABORTED':
      return {
        ...state,
        myQuests: {
          ...state.myQuests,
          isLoading: false,
          isLeavingAQuest: false,
          errors: {
            ...state.myQuests.errors,
            hasError: false,
            code: '',
            message: '',
          },
        },
      };
    case 'LEAVE_QUEST_SUCCESS':
      return {
        ...state,
        myQuests: {
          ...state.myQuests,
          data: [
            ...filter(state.myQuests.data, quest => action.payload.response.quest.id !== quest.id),
          ],
          isLoading: false,
          isLeavingAQuest: false,
          errors: {
            ...state.myQuests.errors,
            hasError: false,
            code: '',
            message: '',
          },
        },
      };
    case 'GET_USER_PAYMENTS_PENDING':
      return {
        ...state,
        myPayments: {
          ...state.myPayments,
          isLoading: true,
          errors: {
            ...state.myPayments.errors,
            hasError: false,
            code: '',
            message: '',
          },
        },
      };
    case 'GET_USER_PAYMENTS_ERROR':
      return {
        ...state,
        myPayments: {
          ...state.myPayments,
          isLoading: false,
          errors: {
            ...state.myPayments.errors,
            hasError: action.payload.error,
            code: action.payload.code,
            message: action.payload.message,
            all: action.payload.errors,
          },
        },
      };
    case 'GET_USER_PAYMENTS_ABORTED':
      return {
        ...state,
        myPayments: {
          ...state.myPayments,
          isLoading: false,
          errors: {
            ...state.myPayments.errors,
            hasError: false,
            code: '',
            message: '',
          },
        },
      };
    case 'GET_USER_PAYMENTS_SUCCESS':
      return {
        ...state,
        myPayments: {
          ...state.myPayments,
          data: action.payload.response.data,
          isLoading: false,
          errors: {
            ...state.myPayments.errors,
            hasError: false,
            code: '',
            message: '',
          },
        },
      };
    case 'GET_USER_TODAY_ACTIVITY_PENDING':
      return {
        ...state,
        todayActivity: {
          ...state.todayActivity,
          isLoading: true,
          errors: {
            ...state.todayActivity.errors,
            hasError: false,
            code: '',
            message: '',
          },
        },
      };
    case 'GET_USER_TODAY_ACTIVITY_ERROR':
      return {
        ...state,
        todayActivity: {
          ...state.todayActivity,
          isLoading: false,
          errors: {
            ...state.todayActivity.errors,
            hasError: action.payload.error,
            code: action.payload.code,
            message: action.payload.message,
            all: action.payload.errors,
          },
        },
      };
    case 'GET_USER_TODAY_ACTIVITY_ABORTED':
      return {
        ...state,
        todayActivity: {
          ...state.todayActivity,
          isLoading: false,
          errors: {
            ...state.todayActivity.errors,
            hasError: false,
            code: '',
            message: '',
          },
        },
      };
    case 'GET_USER_TODAY_ACTIVITY_SUCCESS':
      return {
        ...state,
        todayActivity: {
          ...state.todayActivity,
          data: action.payload.response.data,
          isLoading: false,
          errors: {
            ...state.todayActivity.errors,
            hasError: false,
            code: '',
            message: '',
          },
        },
      };
    case 'GET_USER_REFERRALS_ACTIVITY_PENDING':
      return {
        ...state,
        referralsActivity: {
          ...state.referralsActivity,
          isLoading: true,
          errors: {
            ...state.referralsActivity.errors,
            hasError: false,
            code: '',
            message: '',
          },
        },
      };
    case 'GET_USER_REFERRALS_ACTIVITY_ERROR':
      return {
        ...state,
        referralsActivity: {
          ...state.referralsActivity,
          isLoading: false,
          errors: {
            ...state.referralsActivity.errors,
            hasError: action.payload.error,
            code: action.payload.code,
            message: action.payload.message,
            all: action.payload.errors,
          },
        },
      };
    case 'GET_USER_REFERRALS_ACTIVITY_ABORTED':
      return {
        ...state,
        referralsActivity: {
          ...state.referralsActivity,
          isLoading: false,
          errors: {
            ...state.referralsActivity.errors,
            hasError: false,
            code: '',
            message: '',
          },
        },
      };
    case 'GET_USER_REFERRALS_ACTIVITY_SUCCESS':
      return {
        ...state,
        referralsActivity: {
          ...state.referralsActivity,
          data: action.payload.response.data,
          isLoading: false,
          errors: {
            ...state.referralsActivity.errors,
            hasError: false,
            code: '',
            message: '',
          },
        },
      };
    case 'GET_USER_TIMED_ACTIVITY_PENDING':
      return {
        ...state,
        timedActivity: {
          ...state.timedActivity,
          isLoading: true,
          errors: {
            ...state.timedActivity.errors,
            hasError: false,
            code: '',
            message: '',
          },
        },
      };
    case 'GET_USER_TIMED_ACTIVITY_ERROR':
      return {
        ...state,
        timedActivity: {
          ...state.timedActivity,
          isLoading: false,
          errors: {
            ...state.timedActivity.errors,
            hasError: action.payload.error,
            code: action.payload.code,
            message: action.payload.message,
            all: action.payload.errors,
          },
        },
      };
    case 'GET_USER_TIMED_ACTIVITY_ABORTED':
      return {
        ...state,
        timedActivity: {
          ...state.timedActivity,
          isLoading: false,
          errors: {
            ...state.timedActivity.errors,
            hasError: false,
            code: '',
            message: '',
          },
        },
      };
    case 'GET_USER_TIMED_ACTIVITY_SUCCESS':
      return {
        ...state,
        timedActivity: {
          ...state.timedActivity,
          data: action.payload.response.data,
          isLoading: false,
          errors: {
            ...state.timedActivity.errors,
            hasError: false,
            code: '',
            message: '',
          },
        },
      };
    case 'SUBMIT_LINK_PENDING':
      return {
        ...state,
        link: {
          ...state.link,
          isLoading: true,
          errors: {
            ...state.link.errors,
            hasError: false,
            code: '',
            message: '',
          },
        },
      };
    case 'SUBMIT_LINK_ERROR':
      return {
        ...state,
        link: {
          ...state.link,
          isLoading: false,
          errors: {
            ...state.link.errors,
            hasError: action.payload.error,
            code: action.payload.code,
            message: action.payload.message,
            all: action.payload.errors,
          },
        },
      };
    case 'SUBMIT_LINK_ABORTED':
      return {
        ...state,
        link: {
          ...state.link,
          isLoading: false,
          errors: {
            ...state.link.errors,
            hasError: false,
            code: '',
            message: '',
          },
        },
      };
    case 'SUBMIT_LINK_SUCCESS':
      return {
        ...state,
        link: {
          ...state.link,
          data: action.payload.response.data,
          isLoading: false,
          errors: {
            ...state.link.errors,
            hasError: false,
            code: '',
            message: '',
          },
        },
      };
    case 'GET_MY_QUESTS_PAGE_DATA_PENDING':
      return {
        ...state,
        myQuests: {
          ...state.myQuests,
          isLoading: true,
          errors: {
            ...state.myQuests.errors,
            hasError: false,
            code: '',
            message: '',
          },
        },
        myUserQuests: {
          ...state.myUserQuests,
          isLoading: true,
          errors: {
            ...state.myUserQuests.errors,
            hasError: false,
            code: '',
            message: '',
          },
        },
        allUserPayments: {
          ...state.allUserPayments,
          isLoading: true,
          errors: {
            ...state.allUserPayments.errors,
            hasError: false,
            code: '',
            message: '',
          },
        },
        tieredActivity: {
          ...state.tieredActivity,
          isLoading: true,
          errors: {
            ...state.tieredActivity.errors,
            hasError: false,
            code: '',
            message: '',
          },
        },
        tieredMultipleDaysActivity: {
          ...state.tieredMultipleDaysActivity,
          isLoading: true,
          errors: {
            ...state.tieredMultipleDaysActivity.errors,
            hasError: false,
            code: '',
            message: '',
          },
        },
      };
    case 'GET_MY_QUESTS_PAGE_DATA_ERROR':
      return {
        ...state,
        myQuests: {
          ...state.myQuests,
          isLoading: false,
          errors: {
            ...state.myQuests.errors,
            hasError: action.payload.error,
            code: action.payload.code,
            message: action.payload.message,
            all: action.payload.errors,
          },
        },
        allUserPayments: {
          ...state.allUserPayments,
          data: action.payload.response?.allUserPayments || {},
          isLoading: false,
          errors: {
            ...state.myQuests.errors,
            hasError: action.payload.error,
            code: action.payload.code,
            message: action.payload.message,
            all: action.payload.errors,
          },
        },
        myUserQuests: {
          ...state.myUserQuests,
          isLoading: false,
          errors: {
            ...state.myUserQuests.errors,
            hasError: action.payload.error,
            code: action.payload.code,
            message: action.payload.message,
            all: action.payload.errors,
          },
        },
        tieredActivity: {
          ...state.tieredActivity,
          isLoading: false,
          errors: {
            ...state.tieredActivity.errors,
            hasError: action.payload.error,
            code: action.payload.code,
            message: action.payload.message,
            all: action.payload.errors,
          },
        },
        tieredMultipleDaysActivity: {
          ...state.tieredMultipleDaysActivity,
          isLoading: false,
          errors: {
            ...state.tieredMultipleDaysActivity.errors,
            hasError: action.payload.error,
            code: action.payload.code,
            message: action.payload.message,
            all: action.payload.errors,
          },
        },
      };
    case 'GET_MY_QUESTS_PAGE_DATA_ABORTED':
      return {
        ...state,
        myQuests: {
          ...state.myQuests,
          isLoading: false,
          errors: {
            ...state.myQuests.errors,
            hasError: false,
            code: '',
            message: '',
          },
        },
        allUserPayments: {
          ...state.allUserPayments,
          isLoading: false,
          errors: {
            ...state.allUserPayments.errors,
            hasError: false,
            code: '',
            message: '',
          },
        },
        myUserQuests: {
          ...state.myUserQuests,
          isLoading: false,
          errors: {
            ...state.myUserQuests.errors,
            hasError: false,
            code: '',
            message: '',
          },
        },
        tieredActivity: {
          ...state.tieredActivity,
          isLoading: false,
          errors: {
            ...state.tieredActivity.errors,
            hasError: false,
            code: '',
            message: '',
          },
        },
        tieredMultipleDaysActivity: {
          ...state.tieredMultipleDaysActivity,
          isLoading: false,
          errors: {
            ...state.tieredMultipleDaysActivity.errors,
            hasError: false,
            code: '',
            message: '',
          },
        },
      };
    case 'GET_MY_QUESTS_PAGE_DATA_SUCCESS':
      return {
        ...state,
        myQuests: {
          ...state.myQuests,
          data: action.payload.response.myQuests,
          isLoading: false,
          errors: {
            ...state.myQuests.errors,
            hasError: false,
            code: '',
            message: '',
          },
        },
        allUserPayments: {
          ...state.allUserPayments,
          data: action.payload.response.allUserPayments,
          isLoading: false,
          errors: {
            ...state.allUserPayments.errors,
            hasError: false,
            code: '',
            message: '',
          },
        },
        myUserQuests: {
          ...state.myUserQuests,
          data: action.payload.response.myUserQuests,
          isLoading: false,
          errors: {
            ...state.myUserQuests.errors,
            hasError: false,
            code: '',
            message: '',
          },
        },
        tieredActivity: {
          ...state.tieredActivity,
          data: action.payload.response.tieredActivity,
          isLoading: false,
          errors: {
            ...state.tieredActivity.errors,
            hasError: false,
            code: '',
            message: '',
          },
        },
        tieredMultipleDaysActivity: {
          ...state.tieredMultipleDaysActivity,
          data: action.payload.response.tieredMultipleDaysActivity,
          isLoading: false,
          errors: {
            ...state.tieredMultipleDaysActivity.errors,
            hasError: false,
            code: '',
            message: '',
          },
        },
      };

    case 'GET_USER_TICKETS_SUCCESS':
      return {
        ...state,
        tickets: {
          data: action.payload.response.data.tickets,
          isLoading: false,
          errors: {
            hasError: false,
            code: '',
            message: '',
          },
        },
      };
    case 'REQUEST_UPDATE_AVATAR_URL_PENDING':
      return {
        ...state,
        preSignedUrl: {
          ...state.preSignedUrl,
          isLoading: true,
          errors: {
            ...state.preSignedUrl.errors,
            hasError: false,
            code: '',
            message: '',
          },
        },
      };
    case 'REQUEST_UPDATE_AVATAR_URL_ERROR':
      return {
        ...state,
        preSignedUrl: {
          ...state.preSignedUrl,
          isLoading: false,
          errors: {
            ...state.preSignedUrl.errors,
            hasError: action.payload.error,
            code: action.payload.code,
            message: action.payload.message,
            all: action.payload.errors,
          },
        },
      };
    case 'REQUEST_UPDATE_AVATAR_URL_ABORTED':
      return {
        ...state,
        preSignedUrl: {
          ...state.preSignedUrl,
          isLoading: false,
          errors: {
            ...state.preSignedUrl.errors,
            hasError: false,
            code: '',
            message: '',
          },
        },
      };
    case 'REQUEST_UPDATE_AVATAR_URL_SUCCESS':
      return {
        ...state,
        preSignedUrl: {
          ...state.preSignedUrl,
          data: action.payload.response.data,
          isLoading: false,
          errors: {
            ...state.preSignedUrl.errors,
            hasError: false,
            code: '',
            message: '',
          },
        },
      };
    case 'GET_BROADCAST_SUCCESS':
      return {
        ...state,
        broadcasts: {
          ...state.broadcasts,
          data: action.payload.response,
          isLoading: false,
        },
      };
    case 'GET_BROADCAST_ABORTED':
      return {
        ...state,
        broadcasts: {
          ...state.broadcasts,
          isLoading: false,
        },
      };
    case 'GET_BROADCAST_CANCELED':
      return {
        ...state,
        broadcasts: {
          ...state.broadcasts,
          isLoading: false,
        },
      };
    case 'GET_BROADCAST_ERROR':
      return {
        ...state,
        broadcasts: {
          ...state.broadcasts,
          isLoading: false,
          errors: {
            ...state.broadcasts.errors,
            hasError: action.payload.error,
            code: action.payload.code,
            message: action.payload.message,
            all: action.payload.errors,
          },
        },
      };
    case 'GET_BROADCAST_PENDING':
      return {
        ...state,
        broadcasts: {
          ...state.broadcasts,
          isLoading: true,
        },
      };
    case 'GET_USER_WALLET_SUCCESS':
      return {
        ...state,
        wallet: {
          data: action.payload.response.data,
          isLoading: false,
          errors: {
            hasError: false,
            code: '',
            message: '',
          },
        },
      };
    case 'WITHDRAW_USER_WALLET_SUCCESS':
      return {
        ...state,
        withdraw: {
          data: action.payload.response.data,
          isLoading: false,
          errors: {
            hasError: false,
            code: '',
            message: '',
          },
        },
      };
    case 'WITHDRAW_USER_WALLET_ERROR':
      return {
        ...state,
        withdraw: {
          ...state.withdraw,
          isLoading: false,
          errors: {
            ...state.withdraw.errors,
            hasError: action.payload.error,
            code: action.payload.code,
            message: action.payload.message,
            all: action.payload.errors,
          },
        },
      };
    case 'WITHDRAW_USER_WALLET_CANCELED':
      return {
        ...state,
        withdraw: {
          ...state.withdraw,
          isLoading: false,
          errors: {
            ...state.withdraw.errors,
            hasError: action.payload.error,
            code: action.payload.code,
            message: action.payload.message,
            all: action.payload.errors,
          },
        },
      };
    case 'WITHDRAW_USER_WALLET_ABORTED':
      return {
        ...state,
        withdraw: {
          ...state.withdraw,
          isLoading: false,
          errors: {
            ...state.withdraw.errors,
            hasError: action.payload.error,
            code: action.payload.code,
            message: action.payload.message,
            all: action.payload.errors,
          },
        },
      };
    case 'WITHDRAW_USER_WALLET_PENDING':
      return {
        ...state,
        withdraw: {
          ...state.withdraw,
          isLoading: true,
          errors: {
            ...state.withdraw.errors,
            hasError: action.payload.error,
            code: action.payload.code,
            message: action.payload.message,
            all: action.payload.errors,
          },
        },
      };
    case 'GET_USER_WALLET_ROLL_OUT_LIST_SUCCESS':
      return {
        ...state,
        rollOuts: {
          ...state.rollOuts,
          data: action.payload.response.data.records,
          pagination: action.payload.response.data.pagination,
          isLoading: false,
          errors: {
            ...state.rollOuts.errors,
            hasError: false,
            code: '',
            message: '',
          },
        },
      };

    case 'GET_USER_WALLET_ROLL_OUT_LIST_PENDING':
      return {
        ...state,
        rollOuts: {
          ...state.rollOuts,
          isLoading: true,
          errors: {
            ...state.rollOuts.errors,
            hasError: false,
            code: '',
            message: '',
          },
        },
      };

    case 'GET_USER_WALLET_ROLL_OUT_LIST_ERROR':
      return {
        ...state,
        rollOuts: {
          ...state.rollOuts,
          isLoading: false,
          errors: {
            ...state.rollOuts.errors,
            hasError: action.payload.error,
            code: action.payload.code,
            message: action.payload.message,
            all: action.payload.errors,
          },
        },
      };

    case 'GET_USER_WALLET_ROLL_OUT_LIST_ABORTED':
      return {
        ...state,
        rollOuts: {
          ...state.rollOuts,
          isLoading: false,
          errors: {
            ...state.rollOuts.errors,
            hasError: false,
            code: '',
            message: '',
          },
        },
      };

    case 'GET_USER_WALLET_ROLL_OUT_CSV_PENDING':
      return {
        ...state,
        rollOutsCsv: {
          ...state.rollOutsCsv,
          isLoading: true,
          errors: {
            ...state.rollOutsCsv.errors,
            hasError: false,
            code: '',
            message: '',
          },
        },
      };

    case 'GET_USER_WALLET_ROLL_OUT_CSV_ERROR':
      return {
        ...state,
        rollOutsCsv: {
          ...state.rollOutsCsv,
          isLoading: false,
          errors: {
            ...state.rollOutsCsv.errors,
            hasError: action.payload.error,
            code: action.payload.code,
            message: action.payload.message,
            all: action.payload.errors,
          },
        },
      };

    case 'GET_USER_WALLET_ROLL_OUT_CSV_ABORTED':
      return {
        ...state,
        rollOutsCsv: {
          ...state.rollOutsCsv,
          isLoading: false,
          errors: {
            ...state.rollOutsCsv.errors,
            hasError: false,
            code: '',
            message: '',
          },
        },
      };

    case 'GET_USER_WALLET_ROLL_OUT_CSV_SUCCESS':
      return {
        ...state,
        rollOutsCsv: {
          ...state.rollOutsCsv,
          data: action.payload.response.data.records,
          pagination: action.payload.response.data.pagination,
          isLoading: false,
          errors: {
            ...state.rollOutsCsv.errors,
            hasError: false,
            code: '',
            message: '',
          },
        },
      };

    case 'GET_USER_WALLET_ROLL_IN_LIST_SUCCESS':
      return {
        ...state,
        rollIns: {
          ...state.rollIns,
          data: action.payload.response.data.records,
          pagination: action.payload.response.data.pagination,
          isLoading: false,
          errors: {
            ...state.rollIns.errors,
            hasError: false,
            code: '',
            message: '',
          },
        },
      };

    case 'GET_USER_WALLET_ROLL_IN_LIST_PENDING':
      return {
        ...state,
        rollIns: {
          ...state.rollIns,
          isLoading: true,
          errors: {
            ...state.rollIns.errors,
            hasError: false,
            code: '',
            message: '',
          },
        },
      };

    case 'GET_USER_WALLET_ROLL_IN_LIST_ERROR':
      return {
        ...state,
        rollIns: {
          ...state.rollIns,
          isLoading: false,
          errors: {
            ...state.rollIns.errors,
            hasError: action.payload.error,
            code: action.payload.code,
            message: action.payload.message,
            all: action.payload.errors,
          },
        },
      };

    case 'GET_USER_WALLET_ROLL_IN_LIST_ABORTED':
      return {
        ...state,
        rollIns: {
          ...state.rollIns,
          isLoading: false,
          errors: {
            ...state.rollIns.errors,
            hasError: false,
            code: '',
            message: '',
          },
        },
      };

    case 'GET_USER_WALLET_ROLL_IN_CSV_PENDING':
      return {
        ...state,
        rollInsCsv: {
          ...state.rollInsCsv,
          isLoading: true,
          errors: {
            ...state.rollInsCsv.errors,
            hasError: false,
            code: '',
            message: '',
          },
        },
      };

    case 'GET_USER_WALLET_ROLL_IN_CSV_ERROR':
      return {
        ...state,
        rollInsCsv: {
          ...state.rollInsCsv,
          isLoading: false,
          errors: {
            ...state.rollInsCsv.errors,
            hasError: action.payload.error,
            code: action.payload.code,
            message: action.payload.message,
            all: action.payload.errors,
          },
        },
      };

    case 'GET_USER_WALLET_ROLL_IN_CSV_ABORTED':
      return {
        ...state,
        rollInsCsv: {
          ...state.rollInsCsv,
          isLoading: false,
          errors: {
            ...state.rollInsCsv.errors,
            hasError: false,
            code: '',
            message: '',
          },
        },
      };

    case 'GET_USER_WALLET_ROLL_IN_CSV_SUCCESS':
      return {
        ...state,
        rollInsCsv: {
          ...state.rollInsCsv,
          data: action.payload.response.data.records,
          pagination: action.payload.response.data.pagination,
          isLoading: false,
          errors: {
            ...state.rollInsCsv.errors,
            hasError: false,
            code: '',
            message: '',
          },
        },
      };
    case 'BUY_CDK_SUCCESS':
      return {
        ...state,
        cdkOrder: {
          data: action.payload.response.data,
          isLoading: false,
          errors: {
            hasError: false,
            code: '',
            message: '',
          },
        },
      };
    case 'BUY_CDK_ERROR':
      return {
        ...state,
        cdkOrder: {
          ...state.cdkOrder,
          isLoading: false,
          errors: {
            ...state.cdkOrder.errors,
            hasError: action.payload.error,
            code: action.payload.code,
            message: action.payload.message,
            all: action.payload.errors,
          },
        },
      };
    case 'BUY_CDK_PENDING':
      return {
        ...state,
        cdkOrder: {
          ...state.cdkOrder,
          isLoading: true,
          errors: {
            ...state.cdkOrder.errors,
            hasError: false,
            code: '',
            message: '',
          },
        },
      };

    case 'BUY_CDK_ABORTED':
      return {
        ...state,
        cdkOrder: {
          ...state.cdkOrder,
          isLoading: false,
          errors: {
            ...state.cdkOrder.errors,
            hasError: false,
            code: '',
            message: '',
          },
        },
      };
    case 'GET_USER_CDK_ORDER_LIST_SUCCESS':
      return {
        ...state,
        cdkOrders: {
          ...state.cdkOrders,
          data: action.payload.response.data.records,
          pagination: action.payload.response.data.pagination,
          wallet:action.payload.response.data.wallet,
          isLoading: false,
          errors: {
            ...state.cdkOrders.errors,
            hasError: false,
            code: '',
            message: '',
          },
        },
      };

    case 'GET_USER_CDK_ORDER_LIST_PENDING':
      return {
        ...state,
        cdkOrders: {
          ...state.cdkOrders,
          isLoading: true,
          errors: {
            ...state.cdkOrders.errors,
            hasError: false,
            code: '',
            message: '',
          },
        },
      };

    case 'GET_USER_CDK_ORDER_LIST_ERROR':
      return {
        ...state,
        cdkOrders: {
          ...state.cdkOrders,
          isLoading: false,
          errors: {
            ...state.cdkOrders.errors,
            hasError: action.payload.error,
            code: action.payload.code,
            message: action.payload.message,
            all: action.payload.errors,
          },
        },
      };

    case 'GET_USER_CDK_ORDER_LIST_ABORTED':
      return {
        ...state,
        cdkOrders: {
          ...state.cdkOrders,
          isLoading: false,
          errors: {
            ...state.cdkOrders.errors,
            hasError: false,
            code: '',
            message: '',
          },
        },
      };
    case 'CANCEL_CDK_ORDER_SUCCESS':
      return {
        ...state,
        cdkOrder: {
          data: action.payload.response.data,
          code: action.payload.response.code,
          isLoading: false,
          errors: {
            hasError: false,
            code: '',
            message: '',
          },
        },
      };
    case 'CANCEL_CDK_ORDER_ERROR':
      return {
        ...state,
        cdkOrder: {
          ...state.cdkOrder,
          isLoading: false,
          errors: {
            ...state.cdkOrder.errors,
            hasError: action.payload.error,
            code: action.payload.code,
            message: action.payload.message,
            all: action.payload.errors,
          },
        },
      };
    case 'CANCEL_CDK_ORDER_PENDING':
      return {
        ...state,
        cdkOrder: {
          ...state.cdkOrder,
          isLoading: true,
          errors: {
            ...state.cdkOrder.errors,
            hasError: false,
            code: '',
            message: '',
          },
        },
      };

    case 'CANCEL_CDK_ORDER_ABORTED':
      return {
        ...state,
        cdkOrder: {
          ...state.cdkOrder,
          isLoading: false,
          errors: {
            ...state.cdkOrder.errors,
            hasError: false,
            code: '',
            message: '',
          },
        },
      };
    case 'PAY_CDK_ORDER_PENDING':
      return {
        ...state,
        cdkOrder_p: {
          ...state.cdkOrder_p,
          isLoading: true,
          errors: {
            ...state.cdkOrder_p.errors,
            hasError: false,
            code: '',
            message: '',
          },
        },
      };
    case 'PAY_CDK_ORDER_ERROR':
      return {
        ...state,
        cdkOrder_p: {
          ...state.cdkOrder_p,
          isLoading: false,
          errors: {
            ...state.cdkOrder_p.errors,
            hasError: action.payload.error,
            code: action.payload.code,
            message: action.payload.message,
            all: action.payload.errors,
          },
        },
      };
    case 'PAY_CDK_ORDER_ABORTED':
      return {
        ...state,
        cdkOrder_p: {
          ...state.cdkOrder_p,
          isLoading: false,
          errors: {
            ...state.cdkOrder_p.errors,
            hasError: false,
            code: '',
            message: '',
          },
        },
      };
    case 'PAY_CDK_ORDER_SUCCESS':
      return {
        ...state,
        cdkOrder_p: {
          ...state.cdkOrder_p,
          data: action.payload.response.data,
          isLoading: false,
          errors: {
            ...state.cdkOrder_p.errors,
            hasError: false,
            code: '',
            message: '',
          },
        },
      };
    case 'GET_CDK_PAY_ORDER_PENDING':
      return {
        ...state,
        orderLink: {
          ...state.orderLink,
          isLoading: true,
          errors: {
            ...state.orderLink.errors,
            hasError: false,
            code: '',
            message: '',
          },
        },
      };

    case 'GET_CDK_PAY_ORDER_ERROR':
      return {
        ...state,
        orderLink: {
          ...state.orderLink,
          isLoading: false,
          errors: {
            ...state.orderLink.errors,
            hasError: action.payload.error,
            code: action.payload.code,
            message: action.payload.message,
            all: action.payload.errors,
          },
        },
      };

    case 'GET_CDK_PAY_ORDER_ABORTED':
      return {
        ...state,
        orderLink: {
          ...state.orderLink,
          isLoading: false,
          errors: {
            ...state.orderLink.errors,
            hasError: false,
            code: '',
            message: '',
          },
        },
      };

    case 'GET_CDK_PAY_ORDER_SUCCESS':
      return {
        ...state,
        orderLink: {
          ...state.orderLink,
          data: action.payload.response.data,
          isLoading: false,
          errors: {
            ...state.orderLink.errors,
            hasError: false,
            code: '',
            message: '',
          },
        },
      };
    case 'GET_USER_CDK_ORDER_RECORD_SUCCESS':
      return {
        ...state,
        cdkOrders: {
          ...state.cdkOrders,
          data: action.payload.response.data.records,
          pagination: action.payload.response.data.pagination,
          isLoading: false,
          errors: {
            ...state.cdkOrders.errors,
            hasError: false,
            code: '',
            message: '',
          },
        },
      };

    case 'GET_USER_CDK_ORDER_RECORD_PENDING':
      return {
        ...state,
        cdkOrders: {
          ...state.cdkOrders,
          isLoading: true,
          errors: {
            ...state.cdkOrders.errors,
            hasError: false,
            code: '',
            message: '',
          },
        },
      };

    case 'GET_USER_CDK_ORDER_RECORD_ERROR':
      return {
        ...state,
        cdkOrders: {
          ...state.cdkOrders,
          isLoading: false,
          errors: {
            ...state.cdkOrders.errors,
            hasError: action.payload.error,
            code: action.payload.code,
            message: action.payload.message,
            all: action.payload.errors,
          },
        },
      };

    case 'GET_USER_CDK_ORDER_RECORD_ABORTED':
      return {
        ...state,
        cdkOrders: {
          ...state.cdkOrders,
          isLoading: false,
          errors: {
            ...state.cdkOrders.errors,
            hasError: false,
            code: '',
            message: '',
          },
        },
      };
    case 'GET_USER_CDK_ORDER_RECORD_CSV_SUCCESS':
      return {
        ...state,
        cdkOrdersCsv: {
          ...state.cdkOrdersCsv,
          data: action.payload.response.data.records,
          pagination: action.payload.response.data.pagination,
          isLoading: false,
          errors: {
            ...state.cdkOrdersCsv.errors,
            hasError: false,
            code: '',
            message: '',
          },
        },
      };

    case 'GET_USER_CDK_ORDER_RECORD_CSV_PENDING':
      return {
        ...state,
        cdkOrdersCsv: {
          ...state.cdkOrdersCsv,
          isLoading: true,
          errors: {
            ...state.cdkOrdersCsv.errors,
            hasError: false,
            code: '',
            message: '',
          },
        },
      };

    case 'GET_USER_CDK_ORDER_RECORD_CSV_ERROR':
      return {
        ...state,
        cdkOrdersCsv: {
          ...state.cdkOrdersCsv,
          isLoading: false,
          errors: {
            ...state.cdkOrdersCsv.errors,
            hasError: action.payload.error,
            code: action.payload.code,
            message: action.payload.message,
            all: action.payload.errors,
          },
        },
      };

    case 'GET_USER_CDK_ORDER_RECORD_CSV_ABORTED':
      return {
        ...state,
        cdkOrdersCsv: {
          ...state.cdkOrdersCsv,
          isLoading: false,
          errors: {
            ...state.cdkOrdersCsv.errors,
            hasError: false,
            code: '',
            message: '',
          },
        },
      };
    case 'GET_USER_CDK_PRODUCTS_SUCCESS':
      return {
        ...state,
        cdkProducts: {
          ...state.cdkProducts,
          data: action.payload.response.data.records,
          pagination: action.payload.response.data.pagination,
          isLoading: false,
          errors: {
            ...state.cdkProducts.errors,
            hasError: false,
            code: '',
            message: '',
          },
        },
      };

    case 'GET_USER_CDK_PRODUCTS_PENDING':
      return {
        ...state,
        cdkProducts: {
          ...state.cdkProducts,
          isLoading: true,
          errors: {
            ...state.cdkProducts.errors,
            hasError: false,
            code: '',
            message: '',
          },
        },
      };

    case 'GET_USER_CDK_PRODUCTS_ERROR':
      return {
        ...state,
        cdkProducts: {
          ...state.cdkProducts,
          isLoading: false,
          errors: {
            ...state.cdkProducts.errors,
            hasError: action.payload.error,
            code: action.payload.code,
            message: action.payload.message,
            all: action.payload.errors,
          },
        },
      };

    case 'GET_USER_CDK_PRODUCTS_ABORTED':
      return {
        ...state,
        cdkProducts: {
          ...state.cdkProducts,
          isLoading: false,
          errors: {
            ...state.cdkProducts.errors,
            hasError: false,
            code: '',
            message: '',
          },
        },
      };
    default:
      return state;
  }
};

export default user;
